// PERFORMANCE: Removed eager imports - converted to lazy loading
import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { MaintenanceGuard } from './core/guards/maintenance.guard';
import { MenuPermissionGuard } from './core/guards/menu-permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: 'open/:key',
    loadComponent: () =>
      import(
        './shared/components/new-tab-loader-component/new-tab-loader-component.component'
      ).then(m => m.NewTabLoaderComponentComponent),
  },
  {
    path: 'detail/shipment',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/orders/pages/awaiting-shipment/shipment-details').then(
        m => m.ShipmentDetailsComponent
      ),
    title: 'Shipment Details - TIBSS',
  },
  {
    path: 'detail/subscription',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/subscriptions/pages/subscription-details/subscription-details.component').then(
        m => m.SubscriptionDetailsComponent
      ),
    title: 'Subscription Details - TIBSS',
  },
  {
    path: 'detail/payment',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/payments/pages/payments-details/payments-details.component').then(
        m => m.PaymentsDetailsComponent
      ),
    title: 'Payment Details - TIBSS',
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./shared/components/maintenance/maintenance.component').then(
        m => m.MaintenanceComponent
      ),
    title: 'Under Maintenance - TIBSS',
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [MaintenanceGuard, AuthGuard],
    canActivateChild: [MaintenanceGuard, MenuPermissionGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes),
        data: { preload: true, reusable: true, maintenanceKey: 'dashboard' },
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./features/customers/customers.routes').then(m => m.customersRoutes),
        data: { reusable: true, maintenanceKey: 'customers' },
      },
      {
        path: 'review',
        loadChildren: () => import('./features/orders/orders.routes').then(m => m.ordersRoutes),
        data: { reusable: true, maintenanceKey: 'orders' },
      },
      {
        path: 'fullfillment',
        loadComponent: () =>
          import('./features/orders/pages/dropship-orders/dropship-orders/dropship-orders.component').then(
            m => m.DropshipOrdersComponent
          ),
        title: 'Dropship Orders - TIBSS',
        data: { reusable: true, maintenanceKey: 'fullfillment' },
      },
      {
        path: 'fullfillment/shipment-detail',
        loadComponent: () =>
          import('./features/orders/pages/awaiting-shipment/shipment-details').then(
            m => m.ShipmentDetailsComponent
          ),
        title: 'Shipment Details - TIBSS',
        data: { maintenanceKey: 'fullfillment' },
      },
      {
        path: 'awaiting-shipment',
        loadComponent: () =>
          import('./features/orders/pages/awaiting-shipment/awaiting-shipment/awaiting-shipment.component').then(
            m => m.AwaitingShipmentComponent
          ),
        title: 'Awaiting Shipment - TIBSS',
        data: { reusable: true, maintenanceKey: 'awaitingShipment' },
      },
      {
        path: 'ticket-system',
        loadChildren: () =>
          import('./features/tickets/tickets/tickets.routes').then(m => m.ticketsRoutes),
        data: { reusable: true, maintenanceKey: 'tickets' },
      },
      {
        path: 'new-reports',
        loadChildren: () => import('./features/reports/reports.routes').then(m => m.reportsRoutes),
        data: { reusable: true, maintenanceKey: 'reports' },
      },
      {
        path: 'renewal-reports',
        loadChildren: () =>
          import('./features/renewal-reports/renewal-reports.routes').then(
            m => m.RENEWAL_REPORTS_ROUTES
          ),
        title: 'Renewal Reports - TIBSS',
        data: { reusable: true, maintenanceKey: 'renewalReports' },
      },
      {
        path: 'bulk-process',
        loadChildren: () =>
          import('./features/bulk-operations/bulk-operations.routes').then(
            m => m.BULK_OPERATIONS_ROUTES
          ),
          data: { reusable: true, maintenanceKey: 'bulkProcess' },
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/payments.routes').then(m => m.paymentsRoutes),
        data: { reusable: true, maintenanceKey: 'payments' },
      },
      {
        path: 'transaction',
        redirectTo: 'payments',
        data: { reusable: true },
      },
      {
        path: 'user-settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then(m => m.settingsRoutes),
        data: { reusable: true, maintenanceKey: 'settings' },
      },
      {
        path: 'tag-manager',
        loadComponent: () =>
          import('./features/settings/pages/tag-manager/tag-manager-page.component').then(
            m => m.TagManagerPageComponent
          ),
        data: { reusable: true, maintenanceKey: 'settings' },
      },
      {
        path: 'adhoc-invoice',
        loadChildren: () =>
          import('./features/adhoc-invoice/adhoc-invoice.routes').then(m => m.adhocInvoiceRoutes),
        title: 'Ad-hoc Invoice - TIBSS',
        data: { reusable: true, maintenanceKey: 'adhocInvoice' },
      },
      {
        path: 'porting',
        loadChildren: () => import('./features/porting/porting.routes').then(m => m.portingRoutes),
        data: { reusable: true, maintenanceKey: 'porting' },
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./features/subscriptions/subscription.routes').then(m => m.subscritionRoutes),
        data: { reusable: true, maintenanceKey: 'subscriptions' },
      },
      {
        path: 'search-result',
        loadComponent: () =>
          import('./features/search-result/search-result.component').then(
            m => m.SearchResultComponent
          ),
      },
      {
        path: 'search-dashboard',
        loadComponent: () =>
          import('@shared/components/search-dashboard/search-dashboard.component').then(
            m => m.SearchDashboardComponent
          ),
      },
      {
        path: 'enhanced-search-test',
        loadComponent: () =>
          import('@shared/components/enhanced-search-test/enhanced-search-test.component').then(
            m => m.EnhancedSearchTestComponent
          ),
      },
      {
        path: 'demo',
        loadComponent: () =>
          import('./features/tanstack-table-demo/tanstack-table-demo.component').then(
            m => m.TanstackTableDemoComponent
          ),
      },
      {
        path: 'customer-email',
        loadChildren: () =>
          import('./features/customer-email/customer-email.module').then(m => m.CustomerEmailModule),
        data: { reusable: true, maintenanceKey: 'customerEmail' },
      },
      {
        path: 'executive-dashboard',
        loadChildren: () =>
          import('./features/executive-dashboard/executive-dashboard.routes').then(
            m => m.executiveDashboardRoutes
          ),
        title: 'Executive Dashboard - TIBSS',
        data: { maintenanceKey: 'executiveDashboard' },
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('./features/inventory/inventory.routes').then(m => m.inventoryRoutes),
        data: { reusable: true, maintenanceKey: 'inventory' },
        title: 'Inventory - TIBSS',
      },
      {
        path: 'testing-component',
        loadComponent: () =>
          import('./shared/components/table-demo/table-demo.component').then(
            m => m.TableDemoComponent
          ),
        title: 'Enhanced Data Table - Demo & Testing',
      },
      // {
      //   path: 'order-review-development',
      //   loadComponent: () =>
      //     import('./features/order-review/components/order-review-dashboard/order-review-dashboard.component').then(
      //       m => m.OrderReviewDashboardComponent
      //     ),
      //   title: 'Order Review Development - TIBSS',
      // },
    ],
  },
  // TEMPORARY: Theme demo route for testing
  {
    path: 'theme-demo',
    loadComponent: () =>
      import('@shared/components/theme-demo/theme-demo.component').then(m => m.ThemeDemoComponent),
  },
  {
    path: 'success',
    loadComponent: () =>
      import('./shared/components/stripe-success/stripe-success.component')
        .then(m => m.StripeSuccessComponent),
    title: 'Payment Processing'
  },
  {
    path: 'cancel',
    loadComponent: () =>
      import('./shared/components/stripe-success/stripe-success.component')
        .then(m => m.StripeSuccessComponent),
    title: 'Payment Cancelled'
  },
  {
    path: '**',
    loadComponent: () =>
      import('@shared/components/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
